import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import RateAdminBlackoutsScreen from "../../../container/RateAdminScreen/RateAdminBlackoutsScreen";
import CreateRateAdminBlackouts from "../../../container/RateAdminScreen/RateAdminBlackoutsScreen/CreateRateAdminBlackouts";

const RateAdminBlackoutsRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_BLACKOUTS.HOME}
          element={
            <RateAdminBlackoutsScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RATEADMIN_BLACKOUTS.CREATE}
          element={<CreateRateAdminBlackouts />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RATEADMIN_BLACKOUTS.EDIT}
          element={<CreateRateAdminBlackouts isEdit={true} />}
        />
      )}
    </>
  );
};

export default RateAdminBlackoutsRoutes;
